import { Box } from '@mantine/core';
import React, { useState } from 'react';

import { RequestsControlsPanel } from '../components/Requests/ControlsPanel';
import { RequestsDataContent } from '../components/Requests/DataContent';

import { Platforms } from '@/types';

export const Requests = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [platform, setPlatform] = useState<Platforms>(Platforms.telegram);

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: '70px auto' }}>
      <RequestsControlsPanel
        date={selectedDate}
        platform={platform}
        setPlatform={setPlatform}
        setSelectedDate={setSelectedDate}
      />
      <RequestsDataContent platform={platform} selectedDate={selectedDate} />
    </Box>
  );
};
